<template>
    <div>

        <config-main-title>
            Anexo Requerido
        </config-main-title>

        <div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum anexo requerido identificado.'" 
                icon="fa-solid fa-paperclip" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary" v-if="dado.filtros.length">
                                <i class="fa fa-filter mr-1" aria-hidden="true"></i>
                                {{ dado.filtros.length }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_anexo_requerido ? '' : 'Novo' }}
                            Anexo Requerido
                            {{ ( item && item.id_anexo_requerido ) ? '#' + item.id_anexo_requerido : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Título"
                                    placeholder="Informar..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Título"
                                    placeholder="Informar..."
                                    type="select"
                                    :optionsList="[
                                        { id: 'atendimento', search: 'Atendimento' },
                                        { id: 'anamnese', search: 'Consultório' },
                                        { id: 'portal', search: 'Portal de Agendamento' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_model" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Mensagem para o Usuário"
                                    placeholder="Informar mensagem que será apresentação..."
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    required
                                    v-model="item.st_mensagem" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    placeholder="(Opcional)..."
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Tipo de Arquivo"
                                    type="select"
                                    placeholder="Qualquer Arquivo..."
                                    :validate="validate"
                                    service="tipo_arquivos.index"
                                    optionsData="id_tipo_arquivo"
                                    optionsMode="aql"
                                    v-model="item.id_tipo_arquivo" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="cnae" :id="item.id_anexo_requerido" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_anexo_requerido ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['id_unidade_operacao'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\formaPagamento', search:'Forma de Pagamento', service: 'forma_pagamentos.index', nosync: true},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return opcoes;
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        unidade: function () { 
            return this.$util.unidade_operacao(this.id_unidade_operacao);
        },
    },

    methods: { 
        
        incluir () { 
            this.validate = false;

            let item = {
                id_anexo_requerido: null, 
                fl_ativo: true, 
                st_titulo: "",
                st_mensagem: "",
                st_observacoes: "",
                id_tipo_arquivo: "",
                st_model: "atendimento", 
                filtros: [],
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'anexos_requeridos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },

        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'anexos_requeridos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 
            this.$util.toggle(this, { 
                service: 'anexos_requeridos',
                dados: item,
            });
        },
    },

    mounted () { 
        this.load ();

        this.$store.commit('setBreadcrumb',
              [
                { name: "Configurações", path: "/cadastros" },
                { name: "Anexos Requeridos", path: "/config/anexos" },
              ]);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>
